jQuery(function ($) {
  if ($('.js-interview-swiper').length) {
    const interview_swiper = new Swiper('.js-interview-swiper', {
      slidesPerView: 1.3,
      spaceBetween: 32,

      loop: false,
      speed: 2000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.js-interview-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.js-interview-buttonNext',
        prevEl: '.js-interview-buttonPrev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3.3,
          spaceBetween: 34,
        },
      },
    });
  }
});

